import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/politica-de-privacidade',
    element: <PrivacyPage />,
  },
  {
    path: '/obrigado',
    element: <ThankYouPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
